module.exports = __webpack_public_path__ + "img/expired_courses.b96620b5.svg";